import React from 'react'

export const PrivacyBottom = ({ data }: { data: any }) => {
  return (
    <div className="mt-8 text-center [&_a]:text-buttonGradient text-[#101A3699] text-[14px] leading-[1.55]">
      <img
        width={24}
        height={24}
        className="mx-auto max-w-full mb-2"
        src="/quiz/icons/protection.svg"
        alt="vector"
      />
      <p
        className="max-w-[240px] mx-auto font-medium"
        dangerouslySetInnerHTML={{ __html: data.content }}
      ></p>
    </div>
  )
}
